import { render } from "./OrganizationUnits.vue?vue&type=template&id=21373b54&scoped=true"
import script from "./OrganizationUnits.vue?vue&type=script&lang=js"
export * from "./OrganizationUnits.vue?vue&type=script&lang=js"

import "./OrganizationUnits.vue?vue&type=style&index=0&id=21373b54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21373b54"]])

export default __exports__